var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5V8.5M12 8.5V10.5M12 8.5H14M12 8.5H10M8.66667 5.16667C8.66667 5.87391 8.38572 6.55219 7.88562 7.05229C7.38552 7.55238 6.70724 7.83333 6 7.83333C5.29276 7.83333 4.61448 7.55238 4.11438 7.05229C3.61428 6.55219 3.33333 5.87391 3.33333 5.16667C3.33333 4.45942 3.61428 3.78115 4.11438 3.28105C4.61448 2.78095 5.29276 2.5 6 2.5C6.70724 2.5 7.38552 2.78095 7.88562 3.28105C8.38572 3.78115 8.66667 4.45942 8.66667 5.16667V5.16667ZM2 13.8333C2 12.7725 2.42143 11.7551 3.17157 11.0049C3.92172 10.2548 4.93913 9.83333 6 9.83333C7.06087 9.83333 8.07828 10.2548 8.82843 11.0049C9.57857 11.7551 10 12.7725 10 13.8333V14.5H2V13.8333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-add.156ce536049829730ad61f4113435dc3.svg";